<template>
  <section class="relative items-center justify-start w-full">
    <slot />
  </section>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'VHeader',
  setup() {
    const store = useStore();
    const patientGegevens = computed(() => store.getters['patient/getPatientGegevens']);

    return {
      patientGegevens
    };
  },
  data() {
    return {};
  }
};
</script>
